import { useReceiveLogic } from 'src/hooks';
import { ManualCartLoadFlow } from './ManualCartLoadFlow';

export const ReceiveUnsupportedModal = () => {
  const { receiveUnsupported, setReceiveUnsupported } = useReceiveLogic();

  return (
    <ManualCartLoadFlow
      open={receiveUnsupported}
      onClose={() => setReceiveUnsupported(false)}
      page='Receive'
      modal='Unsupported Retailer Modal'
    />
  );
};
